import type {
  BoxListItem,
  CreateProductInput,
  IWarehouseApi,
} from "../../../api/WarehouseApi";
import { Product } from "../../../stores/Product";
import { resolveEntityTypeTags } from "../../../utils/typeTags";

export interface AddProductReferenceData {
  boxes: BoxListItem[];
  typeTagSuggestions: string[];
}

export async function loadAddProductReferenceData(
  api: IWarehouseApi,
): Promise<AddProductReferenceData> {
  const [boxes, products] = await Promise.all([
    api.getAllBoxes(),
    api.getAllProducts(),
  ]);

  const tagSet = new Set<string>();
  products.forEach((product) => {
    resolveEntityTypeTags({
      typeTags: product.typeTags,
    }).forEach((tag) => tagSet.add(tag));
  });

  return {
    boxes,
    typeTagSuggestions: Array.from(tagSet).sort(),
  };
}

export async function submitAddProduct(
  api: IWarehouseApi,
  payload: CreateProductInput,
): Promise<Product> {
  const created = await api.createProduct(payload);
  return new Product(created);
}
